import { useQuery } from "react-query";

import { reportsService } from "services";

const useGetReportQuery = ({
	id,
	fileFormat,
	token,
}: {
	id: string;
	fileFormat: string | number;
	token: string;
}) =>
	useQuery(
		["reportFile", id],
		() => reportsService.getReportForDisplay(id, fileFormat, token),
		{
			retry: 0,
			cacheTime: 0,
		},
	);

export default useGetReportQuery;
